var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.autoEntry)?_c('div',{staticClass:"input"},[_c('div',{staticClass:"button-warning"},[_vm._v("\n    自動承認対象のイベントです！\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }